import { isProd } from "./lib/env-helpers.js";
import { loadScript } from "./lib/load-script.js";
import { attach1MindEventListener } from "./segment/1mind.js";

const onemindCustomerID = isProd() ? "6vlx97mggb" : "95vq7hsd69";
const onemindScriptSrc = `https://launcher.1mind.com/${onemindCustomerID}`;

export function load1Mind({ widget = false, waveform = false } = {}) {
  const options = {};
  if (widget) options["data-display_mode"] = "widget";
  if (waveform) options["data-flow"] = "website-bdr-waveform";
  loadScript(onemindScriptSrc, options);
  attach1MindEventListener();
}
